import { render, staticRenderFns } from "./ModalEditBusinessAccount.vue?vue&type=template&id=9984b7e2&scoped=true"
import script from "./ModalEditBusinessAccount.vue?vue&type=script&lang=js"
export * from "./ModalEditBusinessAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalEditBusinessAccount.vue?vue&type=style&index=0&id=9984b7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9984b7e2",
  null
  
)

export default component.exports